import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import InvoiceTableRow from './row'
import Popup, { PopupTrigger } from '@aytm/lib/rfd-ui/components/basic/popup'
import TextField from '@aytm/lib/rfd-ui/components/basic/text-field'
import { formatCurrency, formatCurrencyStr, filterCurrencyStr } from '@aytm/lib/common/func'

export default class InvoiceTableInputRow extends InvoiceTableRow {
  static propTypes = {
    row: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.number,
    valuesWidth: PropTypes.number,
    onChange: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    this.update = this.update.bind(this);
    this.onChange = this.onChange.bind(this);
    this.parseValue = this.parseValue.bind(this);
    this.parseStr = this.parseStr.bind(this);
  }

  update(val) {
    const { onChange, row } = this.props
    const id = row.get('id')

    if (id && 'function' == typeof onChange) {
      onChange(
        Map({
          [id]: Map({
            type: 'input',
            value: val
          })
        }),
        id,
        false !== row.get('update')
      )
    }
    return false
  }

  onChange(str) {
    const val = this.parseStr(str)
    if (null != val) this.update(val)
    else this.update(0)
  }

  parseValue(val, row = this.props.row) {
    const money = Boolean(Map.isMap(row) && row.get('money'))
    if (money) {
      const valInt = parseInt(val, 10)

      return formatCurrency(isNaN(valInt) ? 0 : valInt / 100)
    } else return val
  }

  parseStr(str, row = this.props.row) {
    const money = Boolean(Map.isMap(row) && row.get('money'))
    if (money) {
      const filteredVal = `${str}`.replace(/[^\d.]+/g, '')
      const valFloat = parseFloat(filteredVal)

      return !isNaN(valFloat) ? Math.floor(valFloat * 100) : null
    } else return str
  }

  renderLeft() {
    const { width, row, updatingFrom } = this.props
    const money = Boolean(Map.isMap(row) && row.get('money'))
    const id = row.get('id')

    return (
      <TextField
        width={width}
        debounce={row.get('debounce')}
        placeholder={row.get('placeholder') ? row.get('placeholder') : money ? '0.00' : ''}
        charLimit={row.get('limit')}
        onChange={this.onChange}
        value={this.parseValue(row.get('inputValue'))}
        error={row.get('error')}
        rows={row.get('rows')}
        prefix={money ? '$' : null}
        prefixWidth={money ? 12 : null}
        filter={money ? filterCurrencyStr : null}
        format={money ? formatCurrencyStr : null}
        icon={id == updatingFrom ? 'aytmfd-spin icon-aytmfd-spin' : null}
        iconColor="#999999"
        className="rfd-ui-invoice-table-input-left-field"
      />
    )
  }

  renderText() {
    const { row } = this.props
    const text = row.get('text')
    const level = row.get('level')
    const textHint = row.get('hintText') || row.get('hintNote')

    return (
      <div className="rfd-ui-invoice-table-dotted">
        <div className="rfd-ui-invoice-table-dotted-text">
          {this.renderLeveledText(text, level, 'rfd-ui-invoice-table-row-label-text')}
          {Map.isMap(textHint) && textHint.has('text') && (
            <PopupTrigger trigger="hover">
              <i key="popupRefEl" className={`icon-aytmfd-${textHint.has('icon') ? textHint.get('icon') : 'help'}`} />
            </PopupTrigger>
          )}
        </div>
      </div>
    )
  }

  renderRight() {
    const { width, row, valuesWidth, updatingFrom } = this.props
    const textHint = row.get('hintText') || row.get('hintNote')
    const money = Boolean(Map.isMap(row) && row.get('money'))
    const id = row.get('id')

    return [
      <div className="rfd-ui-invoice-table-row-label" style={{ width: width }} key="label">
        <div className="rfd-ui-invoice-table-text">
          {Map.isMap(textHint) && textHint.has('text') ? (
            <Popup
              direction={textHint.get('direction') || 'righttop'}
              content={() => <span>{textHint.get('text')}</span>}
              header={() => <span>{textHint.get('title') ? textHint.get('title') : ''} </span>}
              width="200px"
              className="rfd-ui-popup-notification"
            >
              {this.renderText()}
            </Popup>
          ) : (
            this.renderText()
          )}
        </div>
      </div>,
      <div className="rfd-ui-invoice-table-row-value" style={{ width: valuesWidth }} key="input">
        <TextField
          width={valuesWidth}
          debounce={row.get('debounce')}
          placeholder={row.get('placeholder')}
          charLimit={row.get('limit')}
          onChange={this.onChange}
          value={this.parseValue(row.get('inputValue'))}
          error={row.get('error')}
          prefix={money ? '$' : null}
          prefixWidth={money ? 12 : null}
          filter={money ? filterCurrencyStr : null}
          format={money ? formatCurrencyStr : null}
          icon={id == updatingFrom ? 'aytmfd-spin icon-aytmfd-spin' : null}
          iconColor="#999999"
        />
      </div>
    ]
  }

  render() {
    const { row } = this.props
    const left = row.get('left')

    return (
      <div className="rfd-ui-invoice-table-row-container">
        {left && this.renderLeft()}
        {!left && this.renderRight()}
      </div>
    )
  }
}
